/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * DIE FUENF AUSFUEHRUNGEN aus dem Prototyp des Betreibers (21.09.2026,
 * `gemini-code-…html`, fuenf Baender untereinander):
 * 
 *   SCHLICHT — weisser Grund, feiner grauer Rand, blauer Knopf.
 *   HELL     — zartblauer Grund, blauer Rand, dunkelblaue Ueberschrift.
 *   AKZENT   — heller Grund mit farbigem Balken an der linken Kante.
 *   DUNKEL   — dunkler Grund, helle Schrift, heller Knopf.
 *   WARM     — cremefarbener Grund, warmer Rand, orangener Knopf.
 * 
 * NICHT MEHR WAEHLBAR SEIT 24.09.2026. Die neue Vorgabe stellt die
 * Farben einzeln (Verlauf von/bis, Knopf-Grund, Knopf-Schrift); auf die
 * Frage, was aus den Ausfuehrungen wird, entschied der Betreiber: „Raus
 * aus der Maske". Im Schema bleiben sie, damit bestehende Baender weiter
 * laden und ihre Farben behalten.
 * 
 * Wer eine eigene Farbe setzt (`backgroundColor`, `verlaufFarbe`,
 * `knopfFarbe`, `knopfSchriftFarbe`, `fontColor`), uebersteuert damit
 * die Ausfuehrung an dieser einen Stelle.
 * 
 * Ohne Angabe gilt SCHLICHT.
 * @export
 */
export const DatabaseNewsletterAusfuehrung = {
    Schlicht: 'SCHLICHT',
    Hell: 'HELL',
    Akzent: 'AKZENT',
    Dunkel: 'DUNKEL',
    Warm: 'WARM'
} as const;
export type DatabaseNewsletterAusfuehrung = typeof DatabaseNewsletterAusfuehrung[keyof typeof DatabaseNewsletterAusfuehrung];


export function DatabaseNewsletterAusfuehrungFromJSON(json: any): DatabaseNewsletterAusfuehrung {
    return DatabaseNewsletterAusfuehrungFromJSONTyped(json, false);
}

export function DatabaseNewsletterAusfuehrungFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseNewsletterAusfuehrung {
    return json as DatabaseNewsletterAusfuehrung;
}

export function DatabaseNewsletterAusfuehrungToJSON(value?: DatabaseNewsletterAusfuehrung | null): any {
    return value as any;
}

